// @ts-nocheck
import { useState, useMemo } from "react";
//--------------------------------------------------------------------------------------------
import { AsyncFormSelect, SelectOption } from "src/components/common/AsyncSelect";
import { myAxios, MyDate } from "src/components/common/functions";
import { Form, Link } from "react-router-dom";
const buildDefaultTrailerData = () => ({
    trailer: "",
    trailerId: "",
    content: [],
    checkList: []
});
const normalizeTrailerData = trailerStr => {
    if(!trailerStr) return buildDefaultTrailerData();
    try{
        const parsed = JSON.parse(trailerStr);
        return {
            ...buildDefaultTrailerData(),
            ...parsed,
            content: Array.isArray(parsed?.content) ? parsed.content : [],
            checkList: Array.isArray(parsed?.checkList) ? parsed.checkList : []
        };
    }catch{
        return buildDefaultTrailerData();
    }
};
const sectionCardStyle = {
    background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
    border: "1px solid #dbe3ef",
    borderRadius: 16,
    boxShadow: "0 12px 30px rgba(15, 23, 42, 0.06)"
};
const sectionTitleStyle = {
    fontSize: "1.05rem",
    fontWeight: 700,
    color: "#0f172a"
};
const subtleTextStyle = {
    color: "#64748b",
    fontSize: ".92rem"
};
const radioCardStyle = isActive => ({
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "12px 16px",
    borderRadius: 12,
    border: `1px solid ${isActive ? "#0d6efd" : "#dbe3ef"}`,
    background: isActive ? "#eff6ff" : "#ffffff",
    cursor: "pointer",
    minWidth: 140
});
const infoBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 10px",
    borderRadius: 999,
    background: "#e0f2fe",
    color: "#0369a1",
    fontSize: ".8rem",
    fontWeight: 700
};
const listRowStyle = {
    border: "1px solid #e2e8f0",
    borderRadius: 12,
    background: "#ffffff"
};
const checkboxStyle = {
    width: 22,
    height: 22,
    flexShrink: 0
};
//--------------------------------------------------------------------------------------------
export const Allitems = [
    {title: "Spare Med Gloves", qty: 2},
    {title: "Spare Lrg Gloves", qty: 2},
    {title: "Spare X-Lrg Gloves", qty: 2},
    {title: "Box Ear Plugs", qty: 1},
    {title: "Spare safety glasses", qty: 2},
    {title: "Safety glasses strap", qty: 2},
    {title: "Wheel Chock Set", qty: 1},
    {title: "Manhole Hook", qty: 1},
    {title: "Cones", qty: 2},
    {title: "Fire Extinguisher", qty: 1, needtoCheck: true},
    {title: "First Aid Kit", qty: 1, needtoCheck: true},
    {title: "Eye wash", qty: 1, needtoCheck: true},
];
export default function TrailerForm({
    preOrPost, 
    closeIt, 
    /*---- assignment ------------------------------------------------*/
    assignmentId, 
    userName, 
    hasTrailerDefault, 
    trailerStr, 
    trailerId, 
    trailerName
    /*-------------------------------------------------------------*/
}){
    const [hasTrailer, setHasTrailer] = useState(hasTrailerDefault);
    const [selectedTrailer, setSelectedTrailer] = useState<SelectOption | null>(
    trailerId || trailerName
        ? {
            value: trailerId ?? "",
            label: trailerName || trailerId || ""
        }
        : null
    );
    const TRLitems = [
        {title: "44\" Pipe Wrench", qty: 1},
        {title: "Crescent Wrench 18\"", qty: 1},
        {title: "Cheater Bar", qty: 1},
        {title: "Screw Driver Long Flat", qty: 1},
        {title: "Grease Gun 10K PSI", qty: 1, needtoCheck: true}
    ]
    const HPitems = [
        {title: "Hand saw 14\" Steel Skeel", qty: 1},
        {title: "Cement Blade/Asphalt Combo blade", qty: 1},
        {title: "Vibrator Plate", qty: 1},
        {title: "Rake", qty: 1},
        {title: "Flat Shovel", qty: 2},
        {title: "Broom", qty: 1},
        {title: "Mounted Fire Extinguisher", qty: 1},
        {title: "Wheel Chocks (set of 2)", qty: 1},
        {title: "Permanent License Plate", qty: 1},
    ]
    const parsedTrailerData = useMemo(() => normalizeTrailerData(trailerStr), [trailerStr]);
    const [data, setData] = useState(() => parsedTrailerData);
    const list = useMemo(() => data.isHotPatch === "yes"?[
        <>I verified security of all tools and equipment loaded on trailer, there are no loose items on trailer.</>,
        /*hot patch*/<>I verified propane level and function of heating system for hot asphalt, the trailer heats the asphalt and contains enough propane for the day</>,
        <>I verified tire condition, if low please submit equipment incident report, the tires are all safe to drive on.</>,
        <>I verified security of trailer hitch, including locking pin and chains are installed and secure, the trailer is fully and safely hooked up to the truck.</>,
        /*hot patch*/<>I verified unit is emptied at the end of the workday if not scheduled for next day use. This way the asphalt does not dry in the unit.</>,
        <>I verified that the trailer brake control in the vehicle works with the trailer, the trailer brake controller works properly.</>,
        <>I verified that all the lights/brake lights/turn signals work properly. All lights and turn signals work properly.</>,
        <>I will notify supervisor and management if there is any damage, or safety concern with equipment by completing a equipment incident form.</>,
        <>I will leave equipment clean and ready for the next day's work.</>, 
        <>I verify that the vehicle I am driving has a pair of serviceable wheel chocks prior to departure</>
    ]:[
        <>I verified security of all tools and equipment loaded on trailer, there are no loose items on trailer.</>,
        <>I verified tire condition, if low please submit equipment incident report, the tires are all safe to drive on.</>,
        <>I verified security of trailer hitch, including locking pin and chains are installed and secure, the trailer is fully and safely hooked up to the truck.</>,
        <>I verified that the trailer brake control in the vehicle works with the trailer, the trailer brake controller works properly.</>,
        <>I verified that all the lights/brake lights/turn signals work properly. All lights and turn signals work properly.</>,
        <>I will notify supervisor and management if there is any damage, or safety concern with equipment by completing a equipment incident form.</>,
        <>I will leave equipment clean and ready for the next day's work.</>, 
        <>I verify that the vehicle I am driving has a pair of serviceable wheel chocks prior to departure</>
    ], [data.isHotPatch]);
    const updateContentValue = (itemIndex, value) => {
        setData(data => ({
            ...data,
            content: [
                ...data.content.slice(0, itemIndex),
                {
                    ...data.content[itemIndex],
                    value
                },
                ...data.content.slice(itemIndex + 1)
            ]
        }));
    };
    const getInventoryDelta = item => {
        const currentValue = window.parseInt(item.value || item.qty);
        return currentValue - item.qty;
    };
    //--------------------------------------------------------------------------------------------
    const handleFormSubmit = async e => {
        if(hasTrailer === "yes" && !selectedTrailer?.value){
            window.alert("Please select trailer first.");
            return;
        }
        if(hasTrailer === "yes" && data.checkList.some(v => v === false)){
            window.alert("Please submit a vehicle damage report after submit this form.");
        }
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        //---------------------------------------------------
        const vehicleFormRes = await myAxios({ fileName: "assignments/trailerForm.php", formData: formData });
        if(!vehicleFormRes) return;
        closeIt();
    }
    //--------------------------------------------------------------------------------------------
    return(
        <Form onSubmit={handleFormSubmit} className = "pb-3">
            <input type = "hidden" name = "id" value = {assignmentId}/>
            <input type = "hidden" name = "preOrPost" value = {preOrPost}/>
            <input type = "hidden" name = "trailerData" value = {JSON.stringify(data)}/>
            <div className = "my-4 p-4">
                <div className = "d-flex flex-wrap justify-content-between align-items-start gap-3">
                    <div>
                        <h3 className="mb-2">TRAILER INSPECTION FORM</h3>
                        <div style = {subtleTextStyle}>
                            Confirm trailer usage, verify trailer inventory, and complete the inspection checklist before submitting.
                        </div>
                    </div>
                    {trailerStr?
                    <div style = {infoBadgeStyle}>
                        Submitted {parsedTrailerData.submitDate} {parsedTrailerData.submitTime}
                    </div>
                    :null}
                </div>
            </div>
            <div className = "p-4 mb-3" style = {sectionCardStyle}>
                <div style = {sectionTitleStyle}>Trailer Confirmation</div>
                <div className = "mt-1 mb-3" style = {subtleTextStyle}>
                    Confirm whether you are towing a trailer for this assignment.
                </div>
                <div className = "d-flex flex-wrap gap-3">
                    <label htmlFor = {`hasTrailerYes`} style = {radioCardStyle(hasTrailer === "yes")}>
                        <input
                            type = "radio"
                            required = {true}
                            id = {`hasTrailerYes`}
                            name = {`hasTrailer`}
                            checked = {hasTrailer === "yes"}
                            value = "yes"
                            onChange = {() => setHasTrailer("yes")}
                            style = {checkboxStyle}
                        />
                        <span>
                            <strong>Yes</strong>
                            <span className = "d-block" style = {subtleTextStyle}>A trailer inspection is required.</span>
                        </span>
                    </label>
                    <label htmlFor = {`hasTrailerNo`} style = {radioCardStyle(hasTrailer === "no")}>
                        <input
                            type = "radio"
                            required = {true}
                            id = {`hasTrailerNo`}
                            name = {`hasTrailer`}
                            checked = {hasTrailer === "no"}
                            value = "no"
                            onChange = {() => setHasTrailer("no")}
                            style = {checkboxStyle}
                        />
                        <span>
                            <strong>No</strong>
                            <span className = "d-block" style = {subtleTextStyle}>No trailer inspection required.</span>
                        </span>
                    </label>
                </div>
            </div>
            {hasTrailer === "yes"?<>
            <div className = "p-4 mb-3" style = {sectionCardStyle}>
                <div style = {sectionTitleStyle}>Trailer Selection</div>
                <div className = "mt-1 mb-3" style = {subtleTextStyle}>
                    Select the trailer to load its inventory requirements and inspection checklist.
                </div>
                <div className = "d-flex flex-column flex-md-row align-items-md-center gap-3">
                    <label
                        htmlFor = {`trailerId`}
                        className = "fw-bold mb-0"
                        style = {{minWidth: 130}}
                    >
                        Trailer
                    </label>
                    <AsyncFormSelect
                        className = "flex-grow-1"
                        inputId = {`trailerId`}
                        name = "trailerId"
                        required
                        fileName = "common/searchTrailer.php"
                        placeholder = "Search trailer..."
                        value = {selectedTrailer}
                        onChange = {next => {
                            const trailer = next as (SelectOption & { isHotPatch?: string }) | null;
                            setSelectedTrailer(trailer);
                            if(!trailer){
                                setData(parsedTrailerData);
                            }else{
                                const items = trailer.isHotPatch === "yes" ? HPitems : TRLitems;
                                setData(data => ({
                                    ...data, 
                                    content: items
                                }));
                            }
                        }}
                    />
                </div>
                {selectedTrailer?.value?
                <div className = "mt-3">
                    <span style = {infoBadgeStyle}>Selected trailer: {selectedTrailer.label}</span>
                </div>
                :null}
            </div>
            <div>
                {data.content.length?
                <div className = "p-4 mb-3" style = {sectionCardStyle}>
                    <div className = "d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
                        <div style = {sectionTitleStyle}>Inventory Count</div>
                        <span style = {infoBadgeStyle}>{data.content.length} required items</span>
                    </div>
                    <div className = "d-flex flex-column gap-2">
                        {data.content.map((item, itemIndex) => {
                            const delta = getInventoryDelta(item);
                            return (
                                <div key = {itemIndex} className = "d-flex flex-column flex-md-row align-items-md-center gap-3 p-3" style = {listRowStyle}>
                                    <label className = "mb-0 flex-grow-1" htmlFor = {"inventory item " + itemIndex}>
                                        <strong>{item.title}</strong>
                                        <span className = "ms-2 text-info">Expected: {item.qty}</span>
                                    </label>
                                    <input
                                        type = "number"
                                        required
                                        step = {1}
                                        min = {0}
                                        style = {{maxWidth: 120}}
                                        className = "form-control"
                                        id = {"inventory item " + itemIndex}
                                        value = {data.content[itemIndex].value || ""}
                                        onKeyDown = {(e) => ['e','.'].includes(e.key) && e.preventDefault()}
                                        onBlur = {e => {
                                            let value = e.currentTarget.value;
                                            while(value.startsWith("0") && value.length > 1) value = value.slice(1);
                                            updateContentValue(itemIndex, value);
                                        }}
                                        onChange = {e => {
                                            updateContentValue(itemIndex, e.currentTarget.value);
                                        }}
                                    />
                                    <span className = {`fw-bold text-nowrap ${delta > 0 ? "text-success" : delta < 0 ? "text-danger" : "text-body-secondary"}`}>
                                        {delta > 0 ? `+${delta}` : delta}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
                :null}
                <div className = "p-4 mb-3" style = {sectionCardStyle}>
                    <div className = "d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
                        <div style = {sectionTitleStyle}>Inspection Criteria</div>
                        <span style = {infoBadgeStyle}>
                            {data.checkList.filter(Boolean).length}/{list.length} complete
                        </span>
                    </div>
                    <div className = "d-flex flex-column gap-2">
                        {list.map((item, itemIndex) =>
                        <label key = {itemIndex} className = "d-flex align-items-start gap-3 p-3 mb-0" style = {listRowStyle} htmlFor = {"item " + itemIndex}>
                            <input
                                type = "checkbox"
                                style = {{...checkboxStyle, marginTop: 2}}
                                id = {"item " + itemIndex}
                                checked = {data.checkList[itemIndex] ?? false}
                                onChange = {e => {
                                    const checked = e.currentTarget.checked;
                                    setData(data => ({
                                        ...data,
                                        checkList: [
                                        ...data.checkList.slice(0, itemIndex), 
                                        checked,
                                        ...data.checkList.slice(itemIndex + 1)
                                    ]}));
                                }}
                            />
                            <span>{item}</span>
                        </label>)}
                    </div>
                </div>
            </div>
            </>:null}
            <div className = "p-4 mb-3" style = {sectionCardStyle}>
                <div style = {sectionTitleStyle}>Submission Details</div>
                <div className = "row g-3 mt-1">
                    <div className = "col-12 col-md-7">
                        <label className = "required-field fw-bold mb-2 d-block">Member name</label>
                        <input
                            type = "text" 
                            className = "form-control" 
                            disabled
                            name = "memberName"
                            value = {userName} 
                        />
                    </div>
                    <div className = "col-12 col-md-5">
                        <label className = "required-field fw-bold mb-2 d-block">Date</label>
                        <input
                            type = "text"
                            className = "form-control"
                            disabled
                            name = "submitDate" 
                            value = {(new MyDate()).s()}
                        />
                    </div>
                </div>
            </div>
            <div className="pt-2 d-flex flex-wrap gap-2">
                <button children="Submit" type = "submit" className = "btn btn-primary px-4"/>
                <Link children="Back" to=".." relative="path" className="btn btn-outline-secondary ms-sm-auto"/>
            </div>
        </Form>
    )    
}
